import React, { useState, useEffect } from "react"
import logo from "../../UserAssets/images/authenteklogo.png"
import { fetchResellerCompanyLogo, fetchPoweredByLogo } from "../../Redux/Api/fetch.api";

const Footer = ({ qrcodeId }) => {

    const comingqr = qrcodeId;
    const [loading, setLoading] = useState(false);
    const [companyLogo, setCompanyLogo] = useState(null);
    const [powcompanyLogo, setPowCompanyLogo] = useState("");

    useEffect(() => {       
        getResellerCompanyLogo(comingqr);
        getPoweredByCompanyLogo();
    }, []);

    

    const getResellerCompanyLogo = (id) => {
      
        setLoading(true)
        if (id != null) {
            fetchResellerCompanyLogo(id)
                .then(response => {

                    setCompanyLogo(response.data.data)
                    setLoading(false)
                    localStorage.removeItem('qrcodeId');

                })
                .catch((err) => {
                    console.log("Err: ", err);
                })
        }
    }

    const getPoweredByCompanyLogo = () => {

        
        fetchPoweredByLogo()
           
            .then(response => {
               
                if (response.data.success) {
                    setPowCompanyLogo(response.data.data)
                }
            })
            .catch((err) => {
                console.log("Err: ", err);
            })
    }

    return (
        <section class="footer">
            <div class="container-fluid">
                <div class="row">
                  
                    <div class="col-sm-6 text-left wow fadeInUp">
                        {companyLogo != null ?
                            <span>
                                Provided By <img src={companyLogo} alt="Company Logo" className="small-logo" />
                            </span> : ""
                        }
                        </div> 
                    
                    <div className="col-sm-6 center-text text-end">
                        <div className="footer--logo">Powered by <a href="https://authentek.io/" target="_blank"><img src={powcompanyLogo}></img> </a></div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Footer